
import { Injectable } from '@angular/core';
import { WinoSharedModule } from '../wino-shared.module';
import { Router } from '@angular/router';
import { BackendValidator } from '../model/backend-validator';
import { SharedUtils } from './shared-utils';
import { EnumEntity } from '../model/entity';

@Injectable({
    providedIn: WinoSharedModule
  })

export class HttpErrorHandler {

    constructor(private router: Router) {}

    /***********************************************
    public handleErrorStandard(error: Error) {
        console.log("An error occurred - Message: " + error.message + "\n" + error.stack ? error.stack : "");
    }
    ***********************************************/

    public handleError(error: Error, origin: string, action?:ErrorHandlerAction, content?: string[]): string {
        
        const returnValidator: BackendValidator = this.logErrorMessage(error, origin);

        switch(action) {
            case(ErrorHandlerAction.alert): {
                if(SharedUtils.inputValueIsPresent(content) && content.length > 0) {
                    this.handleErrorAlert(content[0]);
                } else {
                    this.handleErrorAlert("Si è verificato un error. Riprovare più tardi");
                }
                break;
            }
            case(ErrorHandlerAction.redirect): {
                if(SharedUtils.inputValueIsPresent(content) && content.length > 0) {
                    this.handleErrorRedirect(content[0]);
                } else {
                    this.handleErrorRedirect(`genericError/Origin: ${origin} - Causa: ${returnValidator.description}`);
                }
                break;
            }
            case(ErrorHandlerAction.alert_redirect): {
                if(SharedUtils.inputValueIsPresent(content) && content.length > 1) {
                    this.handleErrorAlert(content[0]);
                    this.handleErrorRedirect(content[1]);
                } else {
                    this.handleErrorAlert("Si è verificato un error. Riprovare più tardi");
                    this.handleErrorRedirect(`genericError/Origin: ${origin} - Causa: ${returnValidator.description}`);
                }
                break;
            }
            case(ErrorHandlerAction.nothing): {
                break;
            }
            default: {
                this.handleErrorDefault(returnValidator, origin);
                break;
            }
        }
        return ("Error message: " + returnValidator.entity + "." + returnValidator.code + " - " + returnValidator.description);
    }

    private logErrorMessage(error: any, origin: string): BackendValidator {

        let returnValidator: BackendValidator = new BackendValidator();

        if (error.error && error.error.validator !== null && error.error.validator !== undefined) {
            console.log(`A Backend error with VALIDATOR occurred.\n
            Returned error: ${error.error.message}\n
            Actual Class / Component: ${origin}\n
            Origin url: ${error.url}\n
            Error message: ${error.message}\n
            Root cause: ${error.error.errors}.\n\n
            VALIDATOR ERROR - ID: ${error.error.validator.id}, ENTITY: ${error.error.validator.entity}, CODE: ${error.error.validator.code}, DESCRIPTION: ${error.error.validator.description}.
            `);

            returnValidator = error.error.validator;

        } else if (error.error && error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.log(`A client-side or network error occurred.
            Returned error message: ${error.error.message}.
            Returned error composed path: ${error.error.composedPath}.
            Class / Component: ${origin}
            TEST error message 01: ${error.name}
            TEST error message 02: ${error.status}
            TEST error message 03: ${error.statusText}
            TEST error message 04: ${error.type}
            TEST error message 05: ${error.message}
            TEST error message 06: ${error.url}
            TEST error message 07: ${error.headers}`);

            returnValidator.id = 0;
            returnValidator.code = "client_side_error";
            returnValidator.entity = EnumEntity.unknown;
            returnValidator.description = error.error.message + " - Origin: " + origin + ".";

        } else if (error.error) {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.log(`A Backend error occurred.
            Returned error status: ${error.error.status}.
            Returned error message: ${error.error.message}.
            Root cause: ${error.error.errors}.
            Class / Component: ${origin}.
            Origin: ${error.url}
            TEST error message 01: ${error.name}
            TEST error message 02: ${error.status}
            TEST error message 03: ${error.statusText}
            TEST error message 04: ${error.type}
            TEST error message 05: ${error.message}
            TEST error message 06: ${error.url}
            TEST error message 07: ${error.headers}`);

            returnValidator.id = 0;
            returnValidator.code = "backend_side_error";
            returnValidator.entity = EnumEntity.unknown;
            returnValidator.description = error.message + " - Origin: " + origin + ".";
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.log(`A Backend error occurred.
            No Http Error to analyze found.`);
            console.log(`Error: ${error} - Origin: ${origin}.`);

            returnValidator.id = 0;
            returnValidator.code = "backend_side_error";
            returnValidator.entity = EnumEntity.unknown;
            returnValidator.description = error + " - Origin: " + origin + ".";
        }        
        //Return an observable with a user-facing error message.
        //return new Observable<any>();
        //..if you want to throw an exception...
        //this.router.navigateByUrl('genericError/' + 'Origine: ' + origin + ' - Causa: ' + errorMessage);
        return returnValidator;
    }

    handleErrorAlert(message: string): void {
        alert(message);
    }

    handleErrorRedirect(link: string): void {
        this.router.navigateByUrl(link);
    }

    handleErrorDefault(validator: BackendValidator, origin: string): void {

        switch(validator.entity + "." + validator.code) {
            
            case 'USER.wrong_user_or_password': 
                this.router.navigate([""]);
                break;

            case 'PERMISSION.jwe_token_expired':
                //console.log("I'M in ERROR HANDLER - jwe_token_expired");
                this.router.navigate(["winoMembership/login"]);
                break;

            case 'PERMISSION.no_permissions':
                this.router.navigate(["winoMembership/login"]);
                //this.router.navigate(["genericError/", `Origin: ${origin} - Causa: ${validator.description}`]);
                break;
/***************************************            
            case 'USER.no_permission':
                this.router.navigate(["genericError/", `Origin: ${origin} - Causa: ${validator.description}`]);
                break;
 ****************************************/
            case 'USER.email_busy':
                return;
                //return validator.description;
                //this.router.navigate(["genericError/", `Origin: ${origin} - Causa: ${validator.description}`]);
                //break;

            case '.':
                this.router.navigate(["genericError/", `Origin: ${origin} - Causa: ${validator.description}`]);
                break;
        
            default:
                this.router.navigate(["genericError/", `Origin: ${origin} - Causa: ${validator.description}`]);
                break;
        }
    }
}

export enum ErrorHandlerAction {
    nothing = 'nothing',
    alert = 'alert',
    redirect = 'redirect',
    alert_redirect = 'message_redirect'
}